import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
label {
    display: inline-block;
    cursor: pointer;
}
input {
    display: inline-block;
    position: relative;
    top: -9px;
}
.text {
    display: inline-block;
    margin: calc(24px / 2);
    color: #3b3b3b;
}
.label {
    font-size: 12px;
  font-family: 'Nimbus Sans', sans-serif;
  font-weight: 400;
  font-style: normal;
}
.value {
    font-size: 14px;
  font-family: 'Nimbus Sans Light', sans-serif;
  font-style: normal;
}
.benchmark-toggle {
    background: #f7f7f7;
    width: 100%;
    display: block;
    text-align: center;
}
.vertical {
    width: -webkit-max-content;
    width: max-content;
}
.vertical label {
    display: block;
}
input:after {
    content: ' ';
    background-color: inherit;
    display: block;
    border-radius: 2px;
    width: 20px;
    height: 20px;
    font-size: 0;
    text-indent: 100%;
    overflow: hidden;
}
input:checked:after {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0 0 13.890283 9.4852557' height='2.67695mm' width='3.9201465mm'%3E%3Cdefs id='defs3344'/%3E%3Cmetadata id='metadata3347'%3E%3Crdf:RDF%3E%3Ccc:Work rdf:about=''%3E%3Cdc:format%3Eimage/svg%2Bxml%3C/dc:format%3E%3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage'/%3E%3Cdc:title/%3E%3C/cc:Work%3E%3C/rdf:RDF%3E%3C/metadata%3E%3Cg transform='translate%28-24.944623%2C-1015.7298%29' id='layer1'%3E%3Cpath id='path3516' d='m 25.702115%2C1020.1621 4.2088%2C4.303 8.16633%2C-7.9778' style='fill:none%3Bfill-rule:evenodd%3Bstroke:%23ffffff%3Bstroke-width:1.5%3Bstroke-linecap:round%3Bstroke-linejoin:round%3Bstroke-miterlimit:4%3Bstroke-dasharray:none%3Bstroke-opacity:1'/%3E%3C/g%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: 2px 5px;
}
.benchmark-toggle > label {
    text-align: left;
}
`;

export default styles;